export const km = {
  shared_components: {
    common: {
      back: "ត្រឡប់វិញ",
      confirm_cancel: "ប្រាកដថាលុបចោលទេ",
      current_executor: "អ្នកអនុវត្តនាបច្ចុប្បន្ន",
      filter: "ល័ក្ខខ័ណ្ឌពិនិត្យជ្រើសរើស",
      inspector: "អ្នកត្រួតពិនិត្យ",
      load_more: "ទាញទៅខាងលើដើម្បីផ្ទុកជាច្រើន",
      no: "ទេ",
      organization_structure: "រចនាសម្ព័ន្ធក្រុមហ៊ុន",
      please_enter: "សូមបញ្ចូល",
      please_select: "សូមជ្រើសរើស",
      reject: "បដិសេធ",
      required_mark: " *",
      responsible_person: "អ្នកទទួលបន្ទុក",
      status: "ស្ថានភាព",
      submit_date_end: "ពេលវេលាដាក់ស្នើ（បញ្ចប់）",
      submit_date_start: "ពេលវេលាដាក់ស្នើ（ចាប់ផ្តើម）",
      yes: "ចាស់\\បាទ",
      cancel: "លុបចោល",
      confirm: "បញ្ជាក់បន្ថែម",
      no_data: "អត់មានទិន្នន័យ",
      delete: "លុប",
      save: "រក្សារទុក",
      submit: "ដាក់ស្នើ",
      map_point: "ការ​សញ្ញា​រូបតំណាង​ផ្ទាត់",
      view_floor_plan: "មើលផែនទីជាន់",
      can_multi_select: "អាចពហុជ្រើសរើស",
      choose_take_photo_msg: "ថតរូបភាព",
      project_cost_center_code: "អង្គភាពទទួលបន្ទុក",
      project_name: "រចនាសម្ព័ន្ធក្រុមហ៊ុន",
      choose: "ជ្រើសរើស",
      get_data_failed: "មិនប្រមូលទិន្នន័យបាន",
      go_back_key_img: "ត្រឡប់វិញ",
      please_select_last_finding_category: "សូមជ្រើសរើសប្រភេទការប្រែប្រួល/ការរកឃើញនៅកម្រិតទាបបំផុត។",
      floor_plan: "ផែនការប្លង់"
    },
    add_inspection_object: {
      inspection_obj_add: "បន្ថែមវត្ថុត្រូវត្រួតពិនិត្យ",
      inspection_obj_input: "សូមបញ្ចូលវត្ថុត្រូវត្រួតពិនិត្យ",
      inspect_object_key: "វត្ថុត្រូវត្រួតពិនិត្យ",
      add_must: "សូមបន្ថែមវត្ថុត្រូវត្រួតពិនិត្យយ៉ាងហោចណាស់មួយ",
      other: "ផ្សេងទៀត"
    },
    corp_select: {
      please_select_last_location_for_inspection: "សូម​ជ្រើស​ទីតាំង​ពិនិត្យ​កម្រិត​ទាប​បំផុត"
    },
    filter_modals: {
      capa_code: "លេខ CAPA",
      capa_exec_date: "កាលបរិច្ឆេទសវនកម្ម/ទទួល",
      capa_final_verifier: "អ្នកផ្ទៀងផ្ទាត់ចុងក្រោយ",
      capa_finding_desc: "ការពិពណ៌នាការរកឃើញ",
      capa_finding_evidence: "ភស្តុតាងការរកឃើញ",
      capa_finding_no: "លេខការរកឃើញ",
      capa_main_process: "ដំណើរការចម្បង",
      capa_person_in_charge: "អ្នកទទួលបន្ទុក",
      capa_source: "ប្រភព CAPA",
      capa_subject_title: "ចំណងជើង CAPA",
      capa_sub_process: "ដំណើរការរង",
      completion_date: "កាលបរិច្ឆេទបញ្ចប់ការងារ",
      corrective_finished: "តើបានបង្ហើយការកែតម្រូវទេ",
      data_scope: "ជួរទិន្នន័យ",
      ehsq_number: "IDនៃការវាយតម្លៃ",
      end_time: "កាលបរិច្ឆេទបញ្ចប់",
      end_time_not_lg_start_time: "ពេលវេលាបញ្ចប់មិនអាចតិចជាងពេលវេលាចាប់ផ្តើម",
      evaluation_method: "វិធីវាយតម្លៃ",
      following_field: "ក្រោយបានរក្សាទុកបញ្ជីភារកិច្ច ឯកសារជួរឈខាងក្រោមនេះទើបតែកើតឡើង",
      from: "(ចាប់ផ្តើម)",
      full_name: "ឈ្មោះ",
      hazard_type: "ប្រភេទនៃគ្រោះថ្នាក់",
      help_center_doc_name: "ឈ្មោះនៃឯកសារ",
      immediate_check_category: "ប្រភេទការត្រួតពិនិត្យ",
      incident_informant: "អ្នករាយការណ៍",
      inspection_level: "ការត្រួតពិនិត្យ",
      job_name: "ឈ្មោះនៃប្រតិបត្តិការ",
      locations: "ទីកន្លែង",
      poba: "ផ្នែករាងកាយដែលរងរបួស",
      project_id: "IDនៃកម្មវិធី",
      project_name: "ឈ្មោះកម្មវិធី",
      rate: "វាយតម្លៃ",
      reporting_department: "ផ្នែករាយការណ៍",
      responsibility_zone: "តំបន់ទទួលខុសត្រូវ",
      audit_reviewer: "អ្នកពិនិត្យនិងផ្ទៀងផ្ទាត់",
      start_time: "កាលបរិច្ឆេទចាប់ផ្តើម",
      start_time_not_lg_end_time: "ពេលវេលាចាប់ផ្តើមមិនអាចធំជាងពេលវេលាបញ្ចប់",
      supplier_id: "នៃអ្នកម៉ោការ",
      target_finished: "តើបានបង្ហើយគោលដៅទេ",
      task_code: "លេខនៃភារកិច្ច",
      to: "(បញ្ចប់)",
      unsafe_behavior: "អំពើគ្មានសុវត្ថិភាព",
      unsafe_condition: "ស្ថានភាពគ្មានសុវត្ថិភាព",
      violation_item: "ចែកការរកឃើញតាមប្រភេទ",
      work_id_id: "IDនៃប្រតិបត្តិការ",
      work_name: "ឈ្មោះនៃប្រតិបត្តិការ",
      work_related: "ពាក់ព័ន្ធនឹងការងារ",
      id_number: "លេខអត្តសញ្ញាណប័ណ្ណ",
      incident_involved_person: "សាមីខ្លួននៃគ្រោះថ្នាក់",
      incident_notifier_pro: "នាយកគម្រោង",
      incident_reporting: "សេចក្តីរាយការណ៍គ្រោះថ្នាក់",
      inspection_finding_category: "បែងចែកការរកឃើញតាមប្រភេទ",
      inspection_form: "តារាងត្រួតពិនិត្យ",
      no: "ទេ",
      project_cost_center: "រចនាសម្ព័ន្ធក្រុមហ៊ុន",
      project_name_bbs: "រចនាសម្ព័ន្ធក្រុមហ៊ុនដែលទទួលខុសត្រូវ",
      reviewer: "អ្នកអត្ថាធិប្បាយ",
      service_type: "ប្រភេទនៃសេវា",
      submit_person: "អ្នករាយការណ៍",
      verification_person: "អ្នកផ្ទៀងផ្ទាត់",
      yes: "ចាស់\\បាទ",
      audit_type_display_key: "ប្រភេទនៃការត្រួតពិនិត្យ",
      business_line: "ខ្សែអាជីវកម្ម",
      cancel_button_key: "លុបចោល",
      check_table_table: "តារាង",
      contractor_company: "ក្រុមហ៊ុនអ្នកម៉ោការ",
      contractor_personnel_id: "IDនៃបុគ្គលិកអ្នកម៉ោការ",
      corrective_action_title_key: "វិធានការកែតម្រូវ",
      due_date_end: "កាលបរិច្ឆេទកំណត់（បញ្ចប់）",
      due_date_start: "កាលបរិច្ឆេទកំណត់（ចាប់ផ្តើម）",
      end_date: "ពេលវេលាបញ្ចប់",
      incident_category: "ប្រភេទនៃគ្រោះថ្នាក់",
      incident_location: "ទីកន្លែងនៃគ្រោះថ្នាក់",
      incident_location_range: "ក្របខ័ណ្ឌនៃទីកន្លែង",
      incident_organization: "អង្គការទទួលបន្ទុក",
      inspection_date_end: "ពេលវេលាត្រួតពិនិត្យ（បញ្ចប់）",
      inspection_date_start: "ពេលវេលាត្រួតពិនិត្យ（ចាប់ផ្តើម）",
      observer: "អ្នកសង្កេត",
      occupation: "វិជ្ជាជីវៈ\\ប្រភេទការងារ",
      org_operation: "តំបន់ធំ",
      report_date_key: "កាលបរិច្ឆេទរាយកាណ៍",
      report_time: "ពេលវេលារាយការណ៍",
      reset: "កត់លក្ខណៈឡើងវិញ",
      schedule_name: "ឈ្មោះផែនការ",
      area: "តំបន់",
      project: "កម្មវិធី",
      years: "ឆ្នាំ",
      report_start_time: "ពេលវេលាចាប់ផ្តើម",
      report_end_time: "ពេលវេលាបញ្ចប់",
      audit_type: "ប្រភេទការត្រួតពិនិត្យ",
      search_view_task_no_key: "លេខភារកិច្ច",
      select_upper_org_structure: "ត្រូវតែជ្រើសរើសរចនាសម្ព័ន្ធក្រុមហ៊ុនលើ",
      start_date: "ពេលវេលាចាប់ផ្តើម",
      task_type: "ប្រភេទនៃការត្រួតពិនិត្យ",
      work_area: "តំបន់ត្រូវសង្កេត",
      work_risk_level: "ថ្នាក់ហានិភ័យនៃការងារ",
      working_area: "តំបន់ធ្វើការ",
      select_current_executor: "ជ្រើសរើសអ្នកអនុវត្តបច្ចុប្បន្ន",
      select_final_verifier: "ជ្រើសរើសអ្នកផ្ទៀងផ្ទាត់ចុងក្រោយ",
      select_person_in_charge: "ជ្រើសរើសអ្នកទទួលបន្ទុក",
      select_reporter: "ជ្រើសរើសអ្នករាយការណ៍",
      select_reviewer: "ជ្រើសរើសអ្នកពិនិត្យ",
      select_verifier: "ជ្រើសរើសអ្នកផ្ទៀងផ្ទាត់",
      incident_schedule: "វឌ្ឍនភាព",
      task_name: "ឈ្មោះនៃភារកិច្ច",
      incident_subject: "ប្រធានបទនៃគ្រោះថ្នាក់",
      accident_number: "លេខនៃគ្រោះថ្នាក់",
      select_capa_source: "ជ្រើសរើសប្រភព CAPA",
      search_capa_source: "ស្វែងរកប្រភព CAPA",
      select_factory: "ជ្រើសរើសរោងចក្រ",
      search_factory: "ស្វែងរករោងចក្រ",
      search_employee: "ស្វែងរកបុគ្គលិក"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "មិនទាន់បានជ្រើសរើសតំបន់",
      please_mark_one_point_on_floor_plan: "សូមសម្គាល់ចំណុចមួយនៅលើផែនការប្លង់",
      reset_zoom: "កំណត់ឡើងវិញនូវការពង្រីក",
      selected_areas: "តំបន់ដែលបានជ្រើសរើស"
    },
    image_annotator_modal: {
      arrow: "↗ ព្រួញ",
      cancel: "បោះបង់",
      circle: "○ រង្វង់",
      clear: "✕ សម្អាត",
      pen: "✏ ប៊ិក",
      pinch_zoom: "🤏 ច្របាច់ពីរម្រាមដៃ",
      rect: "□ ប្រអប់",
      save: "រក្សាទុកចំណារ",
      text_tool: "T អក្សរ",
      title_arrow: "ព្រួញ",
      title_circle: "រូបរង្វង់",
      title_pen: "ប៊ិចគូររូប",
      title_rect: "រូបចតុកោណ",
      title_reset_zoom: "កំណត់ការពង្រីកឡើងវិញ",
      title_text: "អក្សរ",
      undo: "↩ មិនធ្វើវិញ"
    },
    my_title: {
      homepage: "ទំព័រដើម",
      enterprise_wechat_exit_home_alert: "ទំព័រចាកចេញ wechat សហគ្រាស"
    },
    no_source_img: {
      no_data: "អត់មានទិន្នន័យ"
    },
    org_select_modal: {
      choose_organization_structure: "ជ្រើសរើសរចនាសម្ព័ន្ធក្រុមហ៊ុន"
    },
    popover_dialog: {
      save_local: "រក្សាទុកក្នុងទូរស័ព្ទដោយបណ្តោះអាសន្ន"
    },
    return_dialog: {
      close_case: "បិទ",
      invalid: "មោឃ"
    },
    select_picture: {
      choose_from_media_msg: "ជ្រើសរើសពីអាល់ប៊ុម",
      confirm_delete_msg: "ប្រាកដថាលុបចោលទេ?",
      get_image_fail: "ប្រមូលរូបភាពមិនបាន"
    },
    select_picture_new: {
      attachement_download_fail: "ដោនឡូតឯកសារភ្ជាប់មិនបាន",
      be_uploading: "កំពុងដាក់បញ្ចូល",
      cancel_key: "លុបចោល",
      load_from_gallery: "ផ្ទុកពីវិចិត្រសាល",
      select_image_source: "ជ្រើសរើសប្រភពនៃរូបភាព",
      use_camera: "ប្រើប្រាស់កាមេរ៉ា",
      use_file: "ផ្ទុកពីឯកសារ",
      camera_access_denied: "ការចូលប្រើកាមេរ៉ាត្រូវបានបដិសេធ។ សូមបើកនៅក្នុងការកំណត់ប្រព័ន្ធ។",
      camera_not_found: "រកមិនឃើញកាមេរ៉ានៅលើឧបករណ៍នេះទេ។"
    },
    spinner: {
      data_load_msg: "កំពុងដាក់បញ្ចូលទិន្នន័យ សូមរង់ចាំ..."
    },
    svg: {
      top: "កំពូល"
    },
    turn_to_send: {
      mission_assign_success: "ផ្ទេរភារកិច្ចដោយជោគជ័យ",
      report_member: "សមាជិកនៃក្រុមស៊ើបអង្កេត",
      select_mission_assignee_msg: "សូមជ្រើសរើសអ្នកត្រូវផ្ទេរភារកិច្ច",
      turn_to_send: "ផ្ទេរ",
      turn_to_send_to: "ផ្ទេរភារកិច្ចឱ្យ",
      project_cost_center_code: "លេខកូតនៃមជ្ឈិមណ្ឌលតម្លៃដើមកម្មវិធី"
    },
    select_file: {
      unsupported_format_desktop_only: "ទម្រង់ឯកសារភ្ជាប់នេះមិនទាន់គាំទ្រនៅឡើយទេ សូមមើលនៅលើកុំព្យូទ័រ។",
      format_not_supported: "ទម្រង់ឯកសារនេះមិនត្រូវបានគាំទ្រសម្រាប់ការទស្សនាឌីជិតថ្នាលទេ។ សូមប្រើចំណុចប្រទាក់វេបសាយដើម្បីទាញយក និងមើល។"
    },
    fabric_canvas: {
      please_select_first: "គ្មានវត្ថុត្រូវបានជ្រើសរើសទេ។ សូមជ្រើសរើសវត្ថុជាមុនសិន។",
      delete_current_instance_only: "ការដកយកចេញបានបរាជ័យ។ អ្នកអាចលុបតែគំនូរដែលទាក់ទងនឹងទីតាំងនេះប៉ុណ្ណោះ។"
    }
  }
};
